import { render, staticRenderFns } from "./CampaignCosts.vue?vue&type=template&id=fd1df954&"
import script from "./CampaignCosts.vue?vue&type=script&lang=js&"
export * from "./CampaignCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports